module.exports = __webpack_public_path__ + "img/logo-dark4-notext.47c99e0c.svg";